import { Button, Link, ToggleButton, ToggleButtonGroup } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import React, { useState } from "react";
import UGTable from "../../../../../Supporting files/UGTable/UGTable";
import "../ProductConfig.scss";
// import AddFeatures from "../../../../../Components/Broker/ProductConfigurator/AddFeatures/AddFeatures";
import ModifyFeature from "../../../../../Components/Broker/ProductConfigurator/ModifyFeature/ModifyFeature";
// import AddCategory from "../../../../../Components/Broker/ProductConfigurator/Categories/AddCategory";
import { GridCloseIcon } from "@mui/x-data-grid/components/icons";
import { useNavigate } from "react-router-dom";
import SlidingPanel from "react-sliding-side-panel";
import SearchBox from "../../../../../Components/Broker/SearchBarAnimation/SearchBox";
import RemovePopup from "../../../../../Components/Common/CarForm/RemovePopup/RemovePopup";
import MultipleSearchDropdown from "../../../../../Supporting files/MultipleSearchDropdown/MultipleSearchDropdown";
import SearchDropdown from "../../../../../Supporting files/SearchDropdown/SearchDropdown";

function Tpa() {
  const navigate = useNavigate();
  const [removeCategory, setRemoveCategory] = useState(false);
  const [modifyFeature, setModifyFeatures] = useState(false);
  const [openAddForm, setOpenAddForm] = useState(false);
  const [tpaType, setTpaType] = useState<string | null>("Integrated");
  const [intTpa, setIntTpa] = useState("");
  const [fields, setFields] = useState([]);
  const [tpaColumns, setGeneralColumns] = useState([
    {
      field: "sr_no",
      headerName: "TPA ID",
      width: 80,
      check_status: true,
    },
    {
      field: "insurer_logo",
      headerName: "Logo",
      width: 250,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <img
            src={row.insurer_logo}
            style={{
              height: "40px",
              background: "#FFFFFF",
              width: "80px",
              borderRadius: "5px",
              paddingLeft: "5px",
              paddingRight: "5px",
            }}
          />
        );
      },
    },
    {
      field: "insurer_name",
      headerName: "Name",
      width: 1150, //1300,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <button
            style={{
              cursor: "pointer",
              fontWeight: "400",
              color: "#2166AA",
              background: "transparent",
              textDecoration: "none",
            }}
            onClick={() => {
              navigate("/TpaDetails");
            }}
          >
            {row.insurer_name}
          </button>
        );
      },
    },
    {
      field: "action_btns",
      headerName: "Action",
      width: 150,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <Link
            className="blueBtn edit ml-0"
            underline="none"
            onClick={() => {
              setModifyFeatures(true);
            }}
          >
            Edit
          </Link>
        );
      },
    },
  ]);
  const tpaRows = [
    {
      id: 0,
      sr_no: "115624",
      insurer_logo: "./images/insurerlogo/mediassist_logo.svg",
      insurer_name: "Medi Assist",
      // network_hospital: "142",
      // website_url: "www.insurerwebsite.com",
      // action_btns: "Edit",
    },
    {
      id: 1,
      sr_no: "168225",
      insurer_logo: "./images/insurerlogo/paramount_logo.svg",
      insurer_name: "Paramount",
      // network_hospital: "192",
      // website_url: "www.insurerwebsite.com",
      // action_btns: "Edit",
    },
    {
      id: 2,
      sr_no: "556942",
      insurer_logo: "./images/insurerlogo/goodHealth_logo.svg",
      insurer_name: "Good Health",
      // network_hospital: "196",
      // website_url: "www.insurerwebsite.com",
      // action_btns: "Edit",
    },
  ];
  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };
  const changeToggle = (
    event: React.MouseEvent<HTMLElement>,
    newchangeToggle: string | null
  ) => {
    if (newchangeToggle != null) {
      setTpaType(newchangeToggle);
    }
  };
  const intTpa_data = [
    {
      label: "MediAssist Insurance TPA Private Limited",
      value: "MediAssist Insurance TPA Private Limited – www.mediassist.in",
    },
    {
      label: "Paramount TPA Health Services & Insurance TPA Private Limited",
      value:
        "Paramount TPA Health Services & Insurance TPA Private Limited – www.paramounttpa.com",
    },
    {
      label: "Health Heritage TPA Insurance Private Limited",
      value:
        "Health Heritage TPA Insurance Private Limited – www.heritagehealthtpa.com",
    },
    { label: "Raksha TPA website", value: "Raksha TPA website a.com" },
    {
      label: "MDIndia Health Insurance TPA Private Limited",
      value:
        "MDIndia Health Insurance TPA Private Limited – www.mdindiaonline.com",
    },
    {
      label: "Medvantage Insurance TPA Private Limited",
      value: "Medvantage Insurance TPA Private Limited – www.uhcpindia.com",
    },
    {
      label: "TPA Vidal Health Insurance Private Limited",
      value:
        "TPA Vidal Health Insurance Private Limited – www.vidalhealthtpa.com",
    },
    {
      label: "Family Health Plan Insurance FHPL TPA Limited",
      value: "Family Health Plan Insurance FHPL TPA Limited – www.fhpl.net",
    },
    {
      label: "East West Assist Insurance TPA Private Limited",
      value:
        "East West Assist Insurance TPA Private Limited – www.eastwestassist.com",
    },
    {
      label: "Medsave Health TPA Insurance Limited",
      value: "Medsave Health TPA Insurance Limited – www.medsave.in",
    },
    {
      label: "Genins India Insurance TPA Limited",
      value: "Genins India Insurance TPA Limited – www.geninsindia.com",
    },
    {
      label: "HealthIndia TPA Insurance Services Private Limited",
      value:
        "HealthIndia TPA Insurance Services Private Limited – www.healthindiatpa.com",
    },
    {
      label: "Good Health TPA Insurance Limited",
      value: "Good Health TPA Insurance Limited – www.ghpltpa.com",
    },
    {
      label: "Park Mediclaim Insurance TPA Private Limited",
      value:
        "Park Mediclaim Insurance TPA Private Limited – www.parkmediclaim.co.in",
    },
    {
      label: "Safeway Insurance TPA Private Limited",
      value: "Safeway Insurance TPA Private Limited – www.safewaytpa.in",
    },
    {
      label: "Anmol Medicare Insurance TPA Limited",
      value: "Anmol Medicare Insurance TPA Limited – www.anmolmedicare.in",
    },
    {
      label: "Rothshield Insurance TPA Limited",
      value: "Rothshield Insurance TPA Limited – www.rothshield.co.in",
    },
    {
      label: "Ericson TPA Insurance TPA Private Limited",
      value: "Ericson TPA Insurance TPA Private Limited – www.ericsontpa.com",
    },
    {
      label: "Health Insurance TPA of India Limited",
      value: "Health Insurance TPA of India Limited – www.hitpa.co.in",
    },
    {
      label: "Vision Digital TPA Insurance Private Limited",
      value: "Vision Digital TPA Insurance Private Limited – www.visiontpa.in",
    },
  ];
  // const fields_data = [
  //   { key: "Name", value: "Name" },
  //   { key: "URL", value: "URL" },
  //   { key: "Password", value: "Password" },
  //   { key: "Value", value: "Value" },
  //   { key: "Kit Version", value: "Kit Version" },
  //   { key: "Environment", value: "Environment" },
  //   { key: "Broker Code", value: "Broker Code" },
  //   { key: "Broker Username", value: "Broker Username" },
  //   { key: "Broker Password", value: "Broker Password" }
  // ];

  const validateAddNewTPA = () => {
    let hasError = false;
    // if (fields?.length === 0 || tpaType === "Integrated" && !intTpa) { hasError = true }
    if (tpaType === "Integrated" && !intTpa) {
      hasError = true;
    }

    if (!hasError) {
      navigate("/AddNewTpa", { state: { fields: fields } });
    }
  };

  return (
    <Grid container spacing={3}>
      <Grid xs={12}>
        <h3 className="mb-0">Third Party Administrator</h3>
      </Grid>
      <>
        <Grid xs={7} style={{ display: "flex", alignItems: "center" }}>
          <SearchBox />
        </Grid>
        <Grid xs={5} className="text-right">
          <Link
            className="redBtn delete"
            underline="none"
            onClick={() => {
              setRemoveCategory(true);
            }}
          >
            Remove
          </Link>
          <Link
            className="greenBtn addfile"
            underline="none"
            onClick={() => {
              // navigate("/AddNewTpa");
              setOpenAddForm(true);
            }}
          >
            Add New
          </Link>
        </Grid>
        <Grid xs={12}>
          <div style={{ height: 400, width: "100%" }}>
            <UGTable
              header_data={tpaColumns}
              data={tpaRows}
              value_update={updateMasterState}
              attrName={"UGTable"}
            />
          </div>
        </Grid>
      </>
      <RemovePopup
        open_status={removeCategory}
        attrName={setRemoveCategory}
        value_update={updateMasterState}
      />
      <ModifyFeature
        attrName={setModifyFeatures}
        value_update={updateMasterState}
        open_status={modifyFeature}
      />
      <SlidingPanel
        type={"right"}
        isOpen={openAddForm}
        size={75} // backdropClicked={() => { setOpenAddForm(false); }}
      >
        <div>
          <Grid container spacing={3} alignItems="center">
            <Grid xs={10}>
              <h4 className="mb-0 mt-4 ml-0">TPA Details</h4>
            </Grid>
            <Grid xs={2} textAlign="end" className="mt-3">
              <GridCloseIcon
                onClick={() => {
                  setOpenAddForm(false);
                  setTpaType("Integrated");
                  setIntTpa("");
                  setFields([]);
                }}
              />
            </Grid>
            <Grid xs={12} className="pt-0">
              <hr />
            </Grid>
          </Grid>
          <div className="scrollable_area">
            <Grid container spacing={3} className="">
              <Grid xs={12} textAlign={"center"}>
                <h4 className="mb-0">Choose Your TPA</h4>
              </Grid>
              <Grid xs={12} className="text-center">
                <ToggleButtonGroup
                  className="loginTypeToggle"
                  value={tpaType}
                  exclusive
                  onChange={changeToggle}
                >
                  <ToggleButton className="toggle_bottons" value="Integrated">
                    Integrated TPA
                  </ToggleButton>
                  <ToggleButton className="toggle_bottons" value="Custom">
                    Custom TPA
                  </ToggleButton>
                </ToggleButtonGroup>
              </Grid>
              {tpaType === "Integrated" ? (
                <Grid xs={12}>
                  <SearchDropdown
                    class_name="inputField"
                    title="Choose your TPA"
                    value={intTpa}
                    attrName={setIntTpa}
                    value_update={updateMasterState}
                    data={intTpa_data}
                    warn_status={false}
                    error_message="Please select Location"
                  />
                </Grid>
              ) : (
                <Grid xs={12} textAlign={"center"}>
                  Proceed to add new TPA form to till out the details.
                </Grid>
              )}

              {/* <Grid xs={12}>
                <MultipleSearchDropdown
                  class_name="inputField"
                  title="Choose required integrated configuration fields"
                  value={fields}
                  attrName={setFields}
                  value_update={updateMasterState}
                  multiple_data={fields_data}
                />
              </Grid> */}
            </Grid>
          </div>
          <Grid container spacing={3}>
            <Grid xs={12} className="ctaBtn mt-4">
              <Button
                variant="contained"
                className="submitBtn fixedbtn"
                onClick={validateAddNewTPA}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </div>
      </SlidingPanel>
    </Grid>
  );
}

export default Tpa;
